import androidx.compose.runtime.*
import io.github.jan.supabase.auth.auth
import io.github.jan.supabase.auth.status.SessionStatus
import listening.ListeningMenuScreen
import listening.ListeningTask1Screen
import listening.ListeningTask2Screen
import listening.ListeningTask3Screen
import listening.ListeningTask4Screen
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.renderComposable
import reading.PracticeTaskScreen
import reading.ReadingMenuScreen
import reading.ReadingModeSelectionScreen

fun main() {
    renderComposable(rootElementId = "root") {
        var sessionStatus by remember { mutableStateOf<SessionStatus>(SessionStatus.NotAuthenticated(false)) }
        var currentScreen by remember { mutableStateOf(Screen.WELCOME) }
        var selectedTaskNumber by remember { mutableStateOf<Int?>(null) }

        LaunchedEffect(Unit) {
            supabase.auth.sessionStatus.collect { status ->
                sessionStatus = status
                if (status is SessionStatus.Authenticated) {
                    currentScreen = Screen.WELCOME
                }
            }
        }

        // === ГЛАВНЫЙ КОНТЕЙНЕР (Row) ===
        Div({
            style {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Row) // Горизонтальное расположение
                width(100.percent)
                minHeight(100.vh)
            }
        }) {

            // 1. ЛЕВАЯ КОЛОНКА (Реклама)
            // Показываем рекламу только если пользователь внутри приложения (не на экране входа)
            if (sessionStatus is SessionStatus.Authenticated) {
                YandexLeftBanner()
            }

            // 2. ПРАВАЯ КОЛОНКА (Основной контент)
            Div({
                style {
                    flex(1) // Занимает всё оставшееся место
                    position(Position.Relative)
                    // Добавляем скролл, если контент не влезает по высоте
                    property("overflow-y", "auto")
                    height(100.vh)
                }
            }) {

                when (sessionStatus) {
                    is SessionStatus.Authenticated -> {
                        when (currentScreen) {
                            Screen.WELCOME -> WelcomeScreen(
                                onNavigate = { screen ->
                                    when (screen) {
                                        Screen.READING_MENU -> currentScreen = Screen.READING_MODE_SELECTION
                                        Screen.LISTENING_MENU -> currentScreen =
                                            Screen.LISTENING_MODE_SELECTION

                                        Screen.ADMIN_GENERATOR -> currentScreen = Screen.ADMIN_GENERATOR
                                        Screen.STATISTICS -> currentScreen = Screen.STATISTICS

                                        else -> kotlinx.browser.window.alert("В разработке")
                                    }
                                },
                                onLogout = { kotlinx.coroutines.GlobalScope.launch { DataRepository.logout() } }
                            )

                            Screen.READING_MODE_SELECTION -> ReadingModeSelectionScreen(
                                onModeSelected = { isExam ->
                                    currentScreen = if (isExam) Screen.EXAM_RUNNING else Screen.READING_MENU
                                },
                                onBack = { currentScreen = Screen.WELCOME }
                            )

                            Screen.ADMIN_GENERATOR -> AdminGeneratorScreen(
                                onBack = { currentScreen = Screen.WELCOME }
                            )

                            Screen.LISTENING_MODE_SELECTION -> ReadingModeSelectionScreen(
                                onModeSelected = { isExam ->
                                    currentScreen = if (isExam) Screen.EXAM_RUNNING else Screen.LISTENING_MENU
                                },
                                onBack = { currentScreen = Screen.WELCOME }
                            )

                            Screen.READING_MENU -> ReadingMenuScreen(
                                onTaskSelected = { taskNum ->
                                    selectedTaskNumber = taskNum
                                    currentScreen = Screen.PRACTICE_RUNNING
                                },
                                onBack = { currentScreen = Screen.READING_MODE_SELECTION }
                            )

                            Screen.PRACTICE_RUNNING -> PracticeTaskScreen(
                                taskId = selectedTaskNumber ?: 1,
                                onExit = { currentScreen = Screen.READING_MENU }
                            )

                            Screen.EXAM_RUNNING -> {
                                ExamScreen(
                                    onExit = {
                                        // При выходе возвращаемся в меню выбора режима
                                        currentScreen = Screen.READING_MODE_SELECTION
                                    }
                                )
                            }

                            Screen.LISTENING_MENU -> ListeningMenuScreen(
                                onTaskSelected = { taskId ->
                                    selectedTaskNumber = taskId
                                    currentScreen = Screen.LISTENING_RUNNING
                                },
                                onBack = { currentScreen = Screen.WELCOME }
                            )

                            Screen.STATISTICS ->
                                StatisticsScreen(onBack = { currentScreen = Screen.WELCOME })

                            Screen.LISTENING_RUNNING -> {
                                when (selectedTaskNumber) {
                                    11 -> {
                                        // Tarea 1 (Существующая)
                                        ListeningTask1Screen(
                                            taskId = 11,
                                            onExit = { currentScreen = Screen.LISTENING_MENU }
                                        )
                                    }

                                    12 -> {
                                        // --- ДОБАВЛЕНО: Tarea 2 ---
                                        ListeningTask2Screen(
                                            taskId = 12,
                                            onExit = { currentScreen = Screen.LISTENING_MENU }
                                        )
                                    }

                                    13 -> {
                                        ListeningTask3Screen(
                                            taskId = 13,
                                            onExit = { currentScreen = Screen.LISTENING_MENU })
                                    }

                                    14 -> {
                                        ListeningTask4Screen(
                                            taskId = 14,
                                            onExit = { currentScreen = Screen.LISTENING_MENU })
                                    }

                                    else -> {
                                        // Заглушка для остальных
                                        Div({ style { padding(50.px) } }) {
                                            H2 { Text("Tarea en desarrollo 🚧") }
                                            Button({
                                                onClick {
                                                    currentScreen = Screen.LISTENING_MENU
                                                }
                                            }) { Text("Volver") }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    else -> {
                        // Экран авторизации (на всю ширину, без рекламы слева)
                        AuthScreen(onLoginSuccess = { console.log("Login success") })
                    }
                }
            }
        }
    }
}